// Projects.js
export const Projects = [
    {
      image: '/media/weatherr.png',
      title: 'Weather Forecast',
      description: 'A brief description of Project One.',
      link: 'https://development-plum.vercel.app/WeatherApp',
      git : "https://github.com/bhagat272/development/blob/main/src/components/ResponsiveAppBar.js"
    },
    {
      image: '/media/todoap.png',
      title: 'To-Do List',
      description: 'A brief description of Project Two.',
      link: 'https://development-plum.vercel.app/todo',
      git:"https://github.com/bhagat272/development/blob/main/src/components/Todo.js"
    },
    {
      image: '/media/dash.png',
      title: 'Dashboard',
      description: 'A brief description of Project Two.',
      link: 'https://dashboardhttpcart.vercel.app/',
      git:"https://github.com/bhagat272/Dashboard"
    },
    {
      image: '/media/event.png',
      title: 'BookUsNow - Event Detail Website',
      description: 'A brief description of Project Two.',
      link: 'https://bookshowsnow.vercel.app/',
      git:"https://github.com/bhagat272/eventdetailsite"
    },
    {
      image: '/media/amazon.png',
      title: 'Amazon Clone',
      description: 'A brief description of Project Two.',
      link: 'https://development-amazon.vercel.app/',
      git:"https://github.com/bhagat272/amazon"
    },
    {
      image: '/media/mern.png',
      title: 'Mern Project',
      description: 'A brief description of Project Two.',
      link: 'https://mernprojectbysumit.vercel.app/',
      git:"https://github.com/bhagat272/MernStack_Project"
    },
    {
      image: '/media/blog.png',
      title: 'BloggerBytes',
      description: 'A blogging app.',
      link: 'https://bloggerbytes.vercel.app/',
      git:"https://github.com/bhagat272/BlogApp"
    },
    {
      image: '/media/download.jpeg',
      title: 'ShopEase',
      description: 'An E-Commerce mobile app.',
      link: 'https://appetize.io/app/b_4ltivi23xorxdf3e4gtjpygebe',
      git:"https://github.com/bhagat272/ShopEase"
    }
    
    // Add more projects as needed
  ];
  